module.exports = __webpack_public_path__ + "img/will_being_read.304d6ab7.svg";